import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function DiscountIcon(props: IconProps) {
    return <Icon {...props} iconKey={"discount"}/>
}
